import styled from "styled-components";
import theme from "~/styles/theme";

export const PdfHolder = styled.div`
  position: relative;
  text-align: center;
  padding: 23px;
  border-radius: 8px;
  background-color: ${theme.palette.neutral.primary.medium};
  max-width: 320px;
  margin: 0 auto;
  img {
    max-width: 100%;
  }

  @media (min-width: ${theme.breakpoints.values.md}px) {
    max-width: 830px;

    img {
      max-width: 740px;
    }
  }

  .react-pdf__Page__canvas {
    margin: 0 auto;
  }

  .download-text {
    font-family: ${theme.typography.fontFamilyRegular};
    color: ${theme.palette.neutral.primary.key};

    a {
      font-family: ${theme.typography.fontFamily};
      color: ${theme.palette.neutral.primary.key};
      font-weight: 700;
    }
    
    @media (max-width: ${theme.breakpoints.values.sm}px) {
      font-size: 13px;      
    }
  }


`;

export const PdfController = styled.div`
  text-align: center;

  button {

    &:nth-child(1) {
      margin-right: 10px;
    }
    &:nth-child(2) {
      margin-left: 10px;
    }
  
    &:hover {
      border-color: ${theme.palette.neutral.primary.medium};
      color: ${theme.palette.brand.primary.key};
      background-color: ${theme.palette.neutral.primary.medium};
    }
  }
`;

export const IconExternalLink = styled.div`
  position: absolute;
  top: 50px;
  right: 64px;
  padding: 5px;
  background-color: ${theme.palette.neutral.primary.key};
  border-radius: 4px;
  z-index: 1;
  padding: 12px;

  svg {
    width: 45px;
    height: 45px;
  }
`;
